import i18n from "../../../../constants/i18n";
import { CSR_MY_CSR_PERFORMANCE_HEADERS } from "../../../../constants/table-custom-headers/CSR";
import getMyCSRPerformanceStore from "../../../../stores/csr-store/csr-performance";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";

const PerformanceTableData = withLiteObserverAndTheme(() => {
  const performanceData = getMyCSRPerformanceStore()
    .performanceData.get()
    .map((data) => {
      return {
        ...data,
        csrMistakesPageName: data.pageName
      };
    });
  return (
    <Et3Table
      columns={CSR_MY_CSR_PERFORMANCE_HEADERS}
      rows={performanceData}
      title={i18n.get("PERFORMANCE")}
      shouldBeFlagged={false}
      titleKey={"PERFORMANCE"}
    />
  );
});
export default PerformanceTableData;
